import { createReducer } from '@ngrx/store';

import {
  initialPriceState,
  priceReducers,
  updatePriceFilter,
} from './price/price.reducer';
import {
  categoryReducers,
  initialCategoryState,
  updateCategoryFilter,
  updateSubcategoryFilter,
} from './category/category.reducer';
import {
  initialLivingSpaceState,
  livingSpaceReducers,
  updateLivingSpaceFilter,
} from './living-space/living-space.reducer';
import {
  initialRoomCountState,
  roomCountReducers,
  updateRoomCountFilter,
} from './room-count/room-count.reducer';
import {
  initialPropertySpaceState,
  propertySpaceReducers,
  updatePropertySpaceFilter,
} from './property-space/property-space.reducer';
import {
  initialRadiusState,
  radiusReducers,
  updateRadiusFilter,
} from './radius/radius.reducer';
import {
  contractTypeReducers,
  initialContractTypeState,
  updateContractType,
} from './contract-type/contract-type.reducer';
import {
  initialRegionState,
  regionReducers,
  updateRegionFilter,
} from './region/region.reducer';
import { initialSortState, sortReducers } from './sort/sort.reducer';
import {
  initialUsageSpaceState,
  updateUsageSpaceFilter,
  usageSpaceReducers,
} from './usage-space/usage-space.reducer';
import { immerOn } from 'ngrx-immer/store';
import { updateFilter, updateFilterConfig } from './filter.actions';
import { FilterState } from '@immosky/types';
import { updateFilterConfiguration } from './policy/filter-configuration.reducer';

export const initialFilterState: FilterState = {
  price: initialPriceState,
  category: initialCategoryState,
  livingSpace: initialLivingSpaceState,
  roomCount: initialRoomCountState,
  propertySpace: initialPropertySpaceState,
  usageSpace: initialUsageSpaceState,
  radius: initialRadiusState,
  contractType: initialContractTypeState,
  region: initialRegionState,
  sort: initialSortState,
  countries: [],
  isResidia: false
};

export const filterReducer = createReducer(
  initialFilterState,
  ...priceReducers,
  ...categoryReducers,
  ...livingSpaceReducers,
  ...roomCountReducers,
  ...propertySpaceReducers,
  ...usageSpaceReducers,
  ...radiusReducers,
  ...contractTypeReducers,
  ...regionReducers,
  ...sortReducers,

  immerOn(updateFilter, (state: FilterState, filters) => {
    if (filters.contractType) {
      updateContractType(state, filters.contractType);
    }

    if (filters.mainCategory) {
      updateCategoryFilter(state, filters.mainCategory);
    }

    if (filters.subcategory) {
      updateSubcategoryFilter(state, filters.subcategory);
    }

    if (filters.price) {
      updatePriceFilter(state, filters.price);
    }

    if (filters.roomCount) {
      updateRoomCountFilter(state, filters.roomCount);
    }

    if (filters.livingSpace) {
      updateLivingSpaceFilter(state, filters.livingSpace);
    }

    if (filters.usageSpace) {
      updateUsageSpaceFilter(state, filters.usageSpace);
    }

    if (filters.propertySpace) {
      updatePropertySpaceFilter(state, filters.propertySpace);
    }

    if (filters.radius) {
      updateRadiusFilter(state, filters.radius);
    }

    if (filters.regions) {
      updateRegionFilter(state, filters.regions);
    }

    if (filters.countries) {
      state.countries = filters.countries;
    }

    if(filters.isResidia) state.isResidia = filters.isResidia;

  }),

  immerOn(updateFilterConfig, (state: FilterState) => {
    updateFilterConfiguration(state);
  })
);
